import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import Seccion1 from './Seccion1/Video.js'
import Seccion2 from './Seccion2/S2.js';
import Seccion3 from './Seccion3/CuboCarrusel.js'
import Footer from '../Home/Footer/Footer';

function ClonesInfo() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id='clones-info'>
      {isMobile ? (
        <>
        <Seccion1 />
        <Seccion2 />
        <Seccion3 />
        <Footer />
        </>
      ) : (
        <>
          <Seccion1 />
          <Seccion2 />
          <Seccion3 />
          <Footer />
        </>
      )}
    </div>
  );
}

export default ClonesInfo;
